module.exports = __webpack_public_path__ + "static/img/1901_7.9a6ba2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_7.jpg
// module id = mP9v
// module chunks = 1